module.exports = __webpack_public_path__ + "static/media/CLIx-School-ICT-Lab.db4209b9.png";